import { Riconciliazione, SectionVM } from 'civil-status/view-models/step-form';

export const transformerRiconciliazione = (
  idEvento?: number,
  dataSection?: SectionVM
): Riconciliazione | undefined => {
  if (!dataSection) {
    return undefined;
  }

  return {
    key: {
      idEvento,
    },
    dataMatrimonio: dataSection?.dateMarriage
      ? dataSection.dateMarriage.toFormat('yyyy-MM-dd')
      : undefined,
    descUfficianteMatrimonio: dataSection.celebratedBy || undefined,
    dataRiconciliazione: dataSection?.dateReconciliation
      ? dataSection.dateReconciliation.toFormat('yyyy-MM-dd')
      : undefined,
  };
};
